import { render, staticRenderFns } from "./ResourceForm.vue?vue&type=template&id=0512c274&scoped=true"
import script from "./ResourceForm.vue?vue&type=script&lang=js"
export * from "./ResourceForm.vue?vue&type=script&lang=js"
import style0 from "./ResourceForm.vue?vue&type=style&index=0&id=0512c274&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0512c274",
  null
  
)

export default component.exports